import React from 'react'

const Cis3 = () => {
    return (
        <div className='container'>
        <h1>Write a program to print all permutations of a given string</h1>
        <p>A permutation, also called an “arrangement number” or “order,” is a rearrangement of the elements of an ordered list S into a one-to-one correspondence with S itself. A string of length n has n! permutation.&nbsp;</p>
        <p>Source: Mathword(<a target="_blank" rel="noopener noreferrer nofollow" href="http://mathworld.wolfram.com/Permutation.html">http://mathworld.wolfram.com/Permutation.html</a>)</p>
        <p>Below are the permutations of string ABC.&nbsp;<br/>
        ABC ACB BAC BCA CBA CAB</p>

    <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>


<div class="tab-content-wrapper">
<div id="tab-content-1" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;string&gt;</code></div>
<div class="line number3 index2 alt2"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="keyword bold">void</code> <code
        class="plain">permute(string s , string answer)</code></div>
<div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code><code class="plain">(s.length() == 0)</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout&lt;&lt;answer&lt;&lt;</code><code class="string">"&nbsp; "</code><code
        class="plain">;</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code><code class="plain">(</code><code class="color1 bold">int</code> <code
        class="plain">i=0 ; i&lt;s.length() ; i++)</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">char</code> <code class="plain">ch = s[i];</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">string left_substr = s.substr(0,i);</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">string right_substr = s.substr(i+1);</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">string rest = left_substr + right_substr;</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">permute(rest , answer+ch);</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code class="plain">&#125;</code></div>
<div class="line number22 index21 alt1">&nbsp;</div>
<div class="line number23 index22 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number24 index23 alt1"><code class="plain">&#123;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">string s;</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">string answer=</code><code class="string">""</code><code class="plain">;</code></div>
<div class="line number27 index26 alt2">&nbsp;</div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout&lt;&lt;</code><code class="string">"Enter the string : "</code><code
        class="plain">;</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cin&gt;&gt;s;</code></div>
<div class="line number30 index29 alt1">&nbsp;</div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout&lt;&lt;</code><code class="string">"\nAll possible strings are : "</code><code
        class="plain">;</code></div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">permute(s , answer);</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number34 index33 alt1"><code class="plain">&#125;</code></div>
</div>
</div>
<div id="tab-content-2" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="keyword">import</code> <code class="plain">java.util.*;</code>
</div>
<div class="line number2 index1 alt1">&nbsp;</div>
<div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">GFG&#123;</code></div>
<div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number5 index4 alt2"><code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">permute(String s , String answer)</code></div>
<div class="line number6 index5 alt1"><code class="plain">&#123;&nbsp;&nbsp;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(s.length() == </code><code class="value">0</code><code
        class="plain">)</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(answer + </code><code class="string">"&nbsp; "</code><code
        class="plain">);</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code><code class="plain">;</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code><code class="plain">(</code><code class="keyword">int</code> <code
        class="plain">i = </code><code class="value">0</code> <code class="plain">;i &lt; s.length(); i++)</code>
</div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">char</code> <code class="plain">ch = s.charAt(i);</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">String left_substr = s.substring(</code><code class="value">0</code><code
        class="plain">, i);</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">String right_substr = s.substring(i + </code><code class="value">1</code><code
        class="plain">);</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">String rest = left_substr + right_substr;</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">permute(rest, answer + ch);</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number21 index20 alt2"><code class="plain">&#125;</code></div>
<div class="line number22 index21 alt1">&nbsp;</div>
<div class="line number23 index22 alt2"><code class="comments">// Driver code</code></div>
<div class="line number24 index23 alt1"><code class="keyword">public</code> <code class="keyword">static</code>
    <code class="keyword">void</code> <code class="plain">main(String args[])</code></div>
<div class="line number25 index24 alt2"><code class="plain">&#123;</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Scanner scan = </code><code class="keyword">new</code> <code
        class="plain">Scanner(System.in);</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">String s;</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">String answer=</code><code class="string">""</code><code class="plain">;</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(</code><code class="string">"Enter the string : "</code><code
        class="plain">);</code></div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s = scan.next();</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(</code><code class="string">"\nAll possible strings are : "</code><code
        class="plain">);</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">permute(s, answer);</code></div>
<div class="line number36 index35 alt1"><code class="plain">&#125;</code></div>
<div class="line number37 index36 alt2"><code class="plain">&#125;</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code class="comments">// This code is contributed by adityapande88</code>
</div>
</div>
</div> 
<div id="tab-content-3" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="keyword">def</code> <code
        class="plain">permute(s, answer):</code></div>
<div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(</code><code class="functions">len</code><code
        class="plain">(s) </code><code class="keyword">=</code><code class="keyword">=</code> <code
        class="value">0</code><code class="plain">):</code></div>
<div class="line number3 index2 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code><code class="plain">(answer, end </code><code class="keyword">=</code> <code
        class="string">"&nbsp; "</code><code class="plain">)</code></div>
<div class="line number4 index3 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code></div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
        class="functions">range</code><code class="plain">(</code><code class="functions">len</code><code
        class="plain">(s)):</code></div>
<div class="line number7 index6 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ch </code><code class="keyword">=</code> <code class="plain">s[i]</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">left_substr </code><code class="keyword">=</code> <code class="plain">s[</code><code
        class="value">0</code><code class="plain">:i]</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">right_substr </code><code class="keyword">=</code> <code class="plain">s[i </code><code
        class="keyword">+</code> <code class="value">1</code><code class="plain">:]</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">rest </code><code class="keyword">=</code> <code class="plain">left_substr </code><code
        class="keyword">+</code> <code class="plain">right_substr</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">permute(rest, answer </code><code class="keyword">+</code> <code class="plain">ch)</code>
</div>
<div class="line number12 index11 alt1">&nbsp;</div>
<div class="line number13 index12 alt2"><code class="comments"># Driver Code</code></div>
<div class="line number14 index13 alt1"><code class="plain">answer </code><code class="keyword">=</code> <code
        class="plain">""</code></div>
<div class="line number15 index14 alt2">&nbsp;</div>
<div class="line number16 index15 alt1"><code class="plain">s </code><code class="keyword">=</code> <code
        class="functions">input</code><code class="plain">(</code><code
        class="string">"Enter the string : "</code><code class="plain">)</code></div>
<div class="line number17 index16 alt2">&nbsp;</div>
<div class="line number18 index17 alt1"><code class="functions">print</code><code class="plain">(</code><code
        class="string">"All possible strings are : "</code><code class="plain">)</code></div>
<div class="line number19 index18 alt2"><code class="plain">permute(s, answer)</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code
        class="comments"># This code is contributed by Harshit Srivastava</code></div>
</div>
</div>

</div>
</div>
<br /> <br /> <br /> <br /> <br />

</div>
    )
}

export default Cis3
